import TripReviewSubmitContainer from './trip-review-submit-container';

export default TripReviewSubmitContainer;
